import React from "react";
import {
  FormControl,
  makeStyles,
  MenuItem,
  Select,
} from "@material-ui/core";

interface BusStatusFilterProps {
  value: string;
  onChange: (value: string) => void;
}

const useStyles = makeStyles(() => ({
  formControl: {
    minWidth: 140,
  },
  select: {
    backgroundColor: "#fff",
    borderRadius: "2px",
    fontSize: "15px",
    minHeight: "40px",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    boxShadow: "rgba(0, 0, 0, 0.3) 0px 2px 6px",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&:hover": {
      backgroundColor: "#f9f9f9",
    },
  },
  menuItem: {
    fontSize: "15px",
    color: "#2B3674",
    "&:hover": {
      backgroundColor: "#F4F7FE",
    },
    "&.Mui-selected": {
      backgroundColor: "#EDE9FE",
      "&:hover": {
        backgroundColor: "#DDD6FE",
      },
    },
  },
  paper: {
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    marginTop: "4px",
  },
}));

const BusStatusFilter: React.FC<BusStatusFilterProps> = ({
  value,
  onChange,
}) => {
  const classes = useStyles();

  return (
    <FormControl
      variant="outlined"
      className={classes.formControl}
      size="small"
    >
      <Select
        id="filter-status"
        value={value}
        onChange={(e) => onChange(e.target.value as string)}
        displayEmpty
        className={classes.select}
        MenuProps={{
          disablePortal: true,
          PaperProps: {
            className: classes.paper,
          },
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          getContentAnchorEl: null,
        }}
      >
        <MenuItem value="all" className={classes.menuItem}>
          All Bus
        </MenuItem>
        <MenuItem value="online" className={classes.menuItem}>
          Online Bus
        </MenuItem>
        <MenuItem value="offline" className={classes.menuItem}>
          Offline Bus
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default BusStatusFilter;
